import { render, staticRenderFns } from "./cloudImage.vue?vue&type=template&id=57e48208&scoped=true&"
import script from "./cloudImage.vue?vue&type=script&lang=js&"
export * from "./cloudImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e48208",
  null
  
)

export default component.exports